import PropTypes from 'prop-types';
import { useState ,useEffect} from 'react';

// @mui
import { MenuItem, IconButton } from '@mui/material';
import { useSelector } from '../../../../redux/store';
// components
import Iconify from '../../../../components/Iconify';
import MenuPopover from '../../../../components/MenuPopover';

// ----------------------------------------------------------------------

UserMoreMenu.propTypes = {
  onPause: PropTypes.func,
  userName: PropTypes.string,
};

export default function UserMoreMenu(props) {

  const { viewJobPost, EditJobPost, onPause, EnableJobSeek , unPublishJobPost,onCloseFunction, jobType,jobStatus,jobPublish,SettingsJobPost} = props;
  const { updateJobPostPausedata , updateUnPublishSuccData } = useSelector((state) => {
    return {
      updateJobPostPausedata: state && state.myjob && state.myjob.updateJobPostingPaused && state.myjob.updateJobPostingPaused.status ,
      updateUnPublishSuccData: state && state.myjob && state.myjob.updateUnPublishSucc && state.myjob.updateUnPublishSucc.status , 
    };
  });


  const [open, setOpen] = useState(null);
  
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    if(updateJobPostPausedata === 200)
    {
      setOpen(null);
    }
  }, [updateJobPostPausedata]);

  useEffect(() => {
    if(updateUnPublishSuccData === 200)
    {
      setOpen(null);
    }
  }, [updateUnPublishSuccData]);

  
const HandleViewJobPost =() =>{
  viewJobPost()
  handleClose()
}
const HandleEditJobPost= () =>{
  EditJobPost()
  handleClose()
}
const HandleSettingsJobPost= () =>{
  SettingsJobPost()
  handleClose()
}
const HandleSeek =() =>{
  EnableJobSeek()
  handleClose()
}
const HandleOnPause = () =>{
  onPause()
  handleClose()
}
const HandleUnPublishJobPost = () =>{
  unPublishJobPost()
  handleClose()
} 
  return (
    <>
      <IconButton onClick={handleOpen}>
        <Iconify icon={'eva:more-vertical-fill'} width={20} height={20} sx={{color:"#282F2D"}} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        arrow="right-top"
        sx={{
          mt: -1,
          width: 160,
          '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 },
        }}
      >
        <MenuItem onClick={ HandleSettingsJobPost }>
          Settings
        </MenuItem>
        <MenuItem onClick={HandleViewJobPost}>
          View Job Post
        </MenuItem>
        <MenuItem onClick={ HandleEditJobPost }>
          Edit Job Post
        </MenuItem>
        {(jobType && jobType==='office_job') ?  <MenuItem onClick={HandleSeek}>
         Enable Job Seek 
        </MenuItem> : null} 
        <MenuItem onClick={HandleOnPause} >
         { (jobStatus && jobStatus==='Paused') ? "UnPause Job Post" : "Pause Job Post"} 
        </MenuItem>
        <MenuItem onClick={HandleUnPublishJobPost} >
        { (jobPublish && jobPublish==='Published') ? "Unpublish Job Post" : "Publish Job Post"} 
         
        </MenuItem>
      </MenuPopover>
    </>
  );
}
